const linkPath = {
  lineQrCodePath: "https://lin.ee/p51uAFU",
  gamePath: "https://happy88.usun.cash/",
  registerPath: "https://happy88.usun.cash/register",
};

module.exports = linkPath;
